import { useAuth } from 'react-oidc-context';
import { useEffect, useState } from "react";
import { Spin, Row, Col, Button, Typography, Icon } from "antd";

export default function PrivateOauth({initAuth, successHandler, authResponse, children}) {
  const auth = useAuth();
  const isLoading = auth.isLoading
  const isAuthenticated = auth.isAuthenticated
  const user = auth.user?.profile
  const [ email, setEmail ] = useState(null);

  useEffect(() => {
    initAuth({logout: auth.removeUser})
    if(isAuthenticated && user) {
      let email = user.preferred_username
      if(!email) {
        email = user.email
      }
      setEmail(email)
      successHandler(auth.user.id_token, email)
    }
    
  }, [isAuthenticated]);

  return (
    !children ?
      <div className="login" style={{position:'unset', display:'flex', flexDirection:'column', alignItems:'center'}}>
        <Row justify="center" align="middle" style={{ minHeight: "calc(100vh - 200px)" }}>
          <Col xs={22} sm={16} md={12} lg={8} xl={6}>
            <div className="login-content">
              <div className="login-box">
                { isLoading ? (
                  <div style={{ padding: '40px 0' }}>
                    <Spin size="large" />
                    <Typography.Text style={{ display: 'block', marginTop: 16, color: 'rgba(0, 0, 0, .65)' }}>
                      Verificando credenciales...
                    </Typography.Text>
                  </div>
                ) : !isAuthenticated ? (
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: 24 }}>
                      <Icon type="lock" style={{ fontSize: 48, color: '#5b9bd5', marginBottom: 16 }} />
                      <Typography.Title level={2} style={{ margin: '0 0 8px', color: 'rgba(0, 0, 0, .85)' }}>
                        AML Update v2.0
                      </Typography.Title>
                      <Typography.Text style={{ color: 'rgba(0, 0, 0, .65)', fontSize: 14 }}>
                        Inicia sesión para acceder a la plataforma
                      </Typography.Text>
                    </div>
                    
                    <Button 
                      type="primary" 
                      size="large" 
                      icon="user"
                      onClick={auth.signinRedirect}
                      className="login-form-button-portal"
                      style={{ 
                        height: 48,
                        fontSize: 16,
                        fontWeight: 500,
                        borderRadius: 6,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}
                    >
                      Iniciar Sesión
                    </Button>
                    
                    <div style={{ marginTop: 24, fontSize: 12, color: 'rgba(0, 0, 0, .45)' }}>
                      <Icon type="lock" style={{ marginRight: 4 }} />
                      Acceso seguro con OAuth 2.0
                    </div>
                  </div>
                ) : authResponse?.error && (
                  <div>
                    <Typography.Title level={3} style={{ color: 'rgba(0, 0, 0, .85)' }}>
                      {email}
                    </Typography.Title>
                    <Typography.Text style={{ color: '#ff4d4f', marginBottom: 16, display: 'block' }}>
                      {authResponse.msg || "Usuario no habilitado"}
                    </Typography.Text>
                    <Button 
                      onClick={auth.removeUser} 
                      size="large"
                      style={{ marginTop: 16 }}
                    >
                      Cerrar Sesión
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    : children
  );
}